export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
